"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.cameraEventSchema = exports.queryEventsSchema = exports.eventSchema = exports.ruleSeverities = void 0;
exports.validateEvent = validateEvent;
const zod_1 = require("zod");
const devices_1 = require("./devices");
exports.ruleSeverities = ["low", "medium", "high", "critical"];
exports.eventSchema = zod_1.z
    .object({
    eventId: zod_1.z.string(),
    type: zod_1.z.string(),
    severity: zod_1.z.enum(exports.ruleSeverities),
    deviceId: zod_1.z.string().regex(devices_1.deviceIdPattern),
    ts: zod_1.z.string(),
    ctx: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .strict();
exports.queryEventsSchema = zod_1.z
    .object({
    deviceId: zod_1.z.string().regex(devices_1.deviceIdPattern).optional(),
    since: zod_1.z.string().optional(),
    types: zod_1.z.string().optional(),
})
    .strict();
function validateEvent(payload) {
    return exports.eventSchema.parse(payload);
}
exports.cameraEventSchema = zod_1.z.object({
    id: zod_1.z.string(),
    deviceId: zod_1.z.string(),
    channel: zod_1.z.string().default("front"),
    type: zod_1.z.enum(["clip", "snapshot", "alarm"]).default("clip"),
    severity: zod_1.z.enum(["info", "warning", "critical"]).default("info"),
    occurredAt: zod_1.z.string().datetime(),
    clipUrl: zod_1.z.string().url().optional(),
    snapshotUrl: zod_1.z.string().url().optional(),
    streetViewUrl: zod_1.z.string().url().optional(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
});
